<template>
  <div class="fragment">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--33 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_comment'])"></div>
        <TextareaDefault
            :label="$t('common_comment.localization_value.value')"
            v-model="permanentVinylItem.data.comment"
        />
      </div>
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_LengthMM'])"></div>
        <DefaultInput
            :label="$t('common_LengthMM.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': permanentVinylItem.data.Dimensions.validation.dimensionLength}"
            :errorTxt="$t(`${permanentVinylItem.data.Dimensions.validationTranslate.dimensionLength}.localization_value.value`)"
            :error="permanentVinylItem.data.Dimensions.validation.dimensionLength"
            v-model="permanentVinylItem.data.Dimensions.data.dimensionLength"
            @input.native="changeEngravingPrice($event, 'length')"
            @change="calculatePermanentVinylPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_WidthMM'])"></div>
        <DefaultInput
            :label="$t('common_WidthMM.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': permanentVinylItem.data.Dimensions.validation.width}"
            :errorTxt="$t(`${permanentVinylItem.data.Dimensions.validationTranslate.width}.localization_value.value`)"
            :error="permanentVinylItem.data.Dimensions.validation.width"
            v-model="permanentVinylItem.data.Dimensions.data.width"
            @input.native="changeEngravingPrice($event, 'width')"
            @change="calculatePermanentVinylPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingCount'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingCount.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': permanentVinylItem.validation.count}"
            :errorTxt="$t(`${permanentVinylItem.validationTranslate.count}.localization_value.value`)"
            :error="permanentVinylItem.validation.count"
            v-model="permanentVinylItem.data.count"
            @input.native="changeEngravingPrice($event, 'count')"
            @change="(val) => {calculatePermanentVinylPrice(); $emit('changeQuantity', permanentVinylItem.data.customization, val)}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_permanentVinylColor',])"></div>
        <DefaultSelect
            :options="permanentVinylColorOptions"
            :label="$t('calculatorEngraving_permanentVinylColor.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="permanentVinylItem.data.color"
            @change="(val) => {permanentVinylItem.data.color = val; calculatePermanentVinylPrice()}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="permanentVinylItem.data.resultCost"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_engravingAcceptFiles4'])"></div>
      {{ $t('fbm_engravingAcceptFiles4.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="permanentVinylItem.data.File.data.maxCountFiles - Object.keys(permanentVinylItem.data.File.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="permanentVinylItem.data.File.data.files"
                  :multiple="true"
                  :maxCount="permanentVinylItem.data.File.data.maxCountFiles - permanentVinylItem.data.File.data.downloadFiles.length"
                  :maxSize="permanentVinylItem.data.File.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="permanentVinylItem.data.File.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-3"
           v-if="Object.keys(permanentVinylItem.data.File.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in permanentVinylItem.data.File.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import {FBMMixinsHelper} from "@/mixins/FBMMixins/FBMMixins";
import TextareaDefault from "@/components/UI/textarea/TextareaDefault/TextareaDefault";

export default {
  name: "PermanentVinylItem",
  components: {TextareaDefault, DefaultSelect, DefaultInput, DownloadFileBlock, DropZone},

  mixins: [FBMMixinsHelper],

  props: {
    FBM: Object,
    permanentVinylItem: Object,
    permanentVinylColorOptions: Array,
  },
  
  // watch: {
  //   isWarehouseLodz() {
  //     if(this.isWarehouseLodz && this.permanentVinylItem.data.customization) {
  //       this.changeCustomization(null)
  //     }
  //   },
  // },

  methods: {

    // changeCustomization(val) {
    //   let oldCustomization = this.permanentVinylItem.data.customization
    //   this.permanentVinylItem.data.customization = val;
    //   this.calculatePermanentVinylPrice();
    //   this.$emit('changeCustomization', oldCustomization, val, this.permanentVinylItem.data.count)
    // },

    removeTenths() {
      if(('' + this.permanentVinylItem.data.Dimensions.data.dimensionLength).indexOf('.') > -1) this.permanentVinylItem.data.Dimensions.data.dimensionLength = this.permanentVinylItem.data.Dimensions.data.dimensionLength.split('.')[0]
      if(('' + this.permanentVinylItem.data.Dimensions.data.width).indexOf('.') > -1) this.permanentVinylItem.data.Dimensions.data.width = this.permanentVinylItem.data.Dimensions.data.width.split('.')[0]
      if(('' + this.permanentVinylItem.data.count).indexOf('.') > -1) this.permanentVinylItem.data.count = this.permanentVinylItem.data.count.split('.')[0]
    },

    changeEngravingPrice(event, type = false) {

      if(type) {
        switch (type) {
          case 'length':
            this.permanentVinylItem.data.Dimensions.data.dimensionLength = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'width':
            this.permanentVinylItem.data.Dimensions.data.width = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'count':
            this.permanentVinylItem.data.count = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          default:
            break
        }

        /**
         * Remove Tenths
         */
        this.removeTenths()
      }
    },

    calculatePermanentVinylPrice() {
      if(
          (!this.permanentVinylItem.data.Dimensions.data.dimensionLength || this.permanentVinylItem.data.Dimensions.data.dimensionLength.length === 0) ||
          (!this.permanentVinylItem.data.Dimensions.data.width || this.permanentVinylItem.data.Dimensions.data.width.length === 0) ||
          (!this.permanentVinylItem.data.count || this.permanentVinylItem.data.count.length === 0)
      ) {
        return
      }

      let data = {
        // offer: this.permanentVinylItem.data.customization ? this.permanentVinylItem.data.customization?.id : null,
        length: this.permanentVinylItem.data.Dimensions.data.dimensionLength,
        width: this.permanentVinylItem.data.Dimensions.data.width,
        quantity: this.permanentVinylItem.data.count,
      }

      this.$store.dispatch('getPermanentVinylCalcResultInOrder', data).then(response => {
        if(this.getRespData(response)?.rate) {
          this.permanentVinylItem.data.resultCost = parseFloat(this.getRespData(response)?.rate).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.permanentVinylItem.data.File.setFiles(files)

      this.permanentVinylItem.data.File.setFilesMaxSizeError(maxSizeError)

      // this.calculatePermanentVinylPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        let fileKey = Object.keys(this.permanentVinylItem.data.File.data.downloadFiles[index])[0]
        if(fileKey) {
          this.FBM.data.removedCustomizationFiles.push(this.permanentVinylItem.data.File.data.downloadFiles[index][fileKey]?.uuid)
          this.permanentVinylItem.data.File.removeDownloadFile(index)
        }

        // this.$store.dispatch('removeUserDocument', id).then(() => {
        //
        //   this.permanentVinylItem.data.File.removeDownloadFile(index)
        //   // this.FBM.data.EngravingFile.setDownloadFiles([])
        //
        //   // this.calculatePermanentVinylPrice()
        // })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },

}
</script>

<style scoped>

</style>